import { PiniaPlugin, Store } from 'pinia';

import { container } from '@/container';
import { Logger } from '@/services/Logger';
import { Signalr } from '@/services/signalr/Signalr';
import { IDispatchMessage } from '~/api/messages/IDispatchMessage';

export type SignalrMessageHandler = (payload: IDispatchMessage) => void;

export const registeredSignalrMessageHandlers: ThisType<Store> & Record<string, SignalrMessageHandler> = {};

export const SignalrPiniaPlugin: PiniaPlugin = ({ options, store }) => {
  // Services.
  const logger = container.get(Logger);
  const signalr = container.get(Signalr);

  const signalrMessageHandlers = {
    ...(options?.signalrMessageHandlers ?? {}),
  };

  // Automatically process any defined SignalR message handlers (without context).
  Object.entries(signalrMessageHandlers).forEach(([methodName, handler]) => {
    // Register the unbound handler.
    registeredSignalrMessageHandlers[methodName] = handler;

    // Bind the handler to the store.
    signalrMessageHandlers[methodName] = handler;

    // Listen for the SignalR method.
    signalr.hubConnection.on(methodName, (message: IDispatchMessage) => {
      // Ignore inbound messages that have a dedicated response handler (deferred).
      if (signalr.isMessageDeferred(message)) {
        return;
      }

      try {
        handler.call(store, message);
      }
      catch (error) {
        logger.captureException(<Error> error, { tags: { SignalrPiniaPlugin: methodName } });
      }
    });
  });

  store.signalrMessageHandlers = signalrMessageHandlers;
};
